(function () {
  const html = document.querySelector('html');
  const userAgent = navigator.userAgent;
  const OSExc = ['is-mac', 'is-ios'];

  let classBrowser = null,
    classOS = null;

  function getBrowser() {
    let browser = null;

    if (
      (navigator.userAgent.indexOf('Opera') ||
        navigator.userAgent.indexOf('OPR')) != -1
    ) {
      browser = 'is-opera';
    } else if (navigator.userAgent.indexOf('Edge') >= 0) {
      browser = 'is-edge';
    } else if (navigator.userAgent.indexOf('Chrome') != -1) {
      browser = 'is-chrome';
    } else if (navigator.userAgent.indexOf('Safari') != -1) {
      browser = 'is-safari';
    } else if (navigator.userAgent.indexOf('Firefox') != -1) {
      browser = 'is-firefox';
    } else if (
      navigator.userAgent.indexOf('MSIE') != -1 ||
      !!document.documentMode == true
    ) {
      browser = 'is-ie';
    }

    return browser;
  }

  function getOS() {
    const platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null,
      ratio = window.devicePixelRatio || 1,
      screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio,
      };

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'is-mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'is-ios';
      if (screen.width == 1125 && screen.height === 2436) {
        //iphonex screensize
        os += ' is-iphonex';
      }
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'is-windows';
    } else if (/Android/.test(userAgent)) {
      os = 'is-android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'is-linux';
    }

    // alert(os);
    return os;
  }

  classOS = getOS();
  classBrowser = getBrowser();

  // Convert form to json
  function formToJSON(elements) {
    var indexed_array = {};
    $.map(elements, function(n, i) {
      let key = n['name'];
      if (key.startsWith("contact[") && key !== "contact[tags]") {
        let match = key.match(/^contact\[(.+)\]$/);
        if (match) {
          key = match[1]; 
        }
      }
      indexed_array[key] = n['value'];
    });
    return indexed_array;
  }

  function viewAll() {
    const viewAllButtons = document.querySelectorAll(
      '.js-collection-products__view-all'
    );

    Array.prototype.forEach.call(viewAllButtons, function (button) {
      var productList = document.querySelector(button.hash);

      button.addEventListener('click', (e) => {
        e.preventDefault();
        var products = productList.querySelectorAll(
          '.js-collection-products-tile'
        );

        button.closest('.collection-products__view-all-wrapper').style.display =
          'none';
        Array.prototype.forEach.call(products, function (product) {
          product.classList.remove('collection-products-tile--hidden');
        });
      });
    });
  }

  // Country Selector
  function countrySelector() {
    let country_list = '';
    const lang = document.querySelector('input.current-lang').value;
    const dropdown = document.querySelectorAll('select.js-country__selector');

    if (lang == 'fr') {
      country_list =
        'https://cdn.shopify.com/s/files/1/0637/3018/8509/files/country_list_fr.json?v=1709565512';
    } else {
      country_list =
        'https://cdn.shopify.com/s/files/1/0649/6269/1325/files/country_list_en.json?v=1709565154';
    }

    Array.prototype.forEach.call(dropdown, function (select) {
      fetch(country_list)
        .then((response) => response.json())
        .then((data) => {
          data.map((item) => {
            const option = document.createElement('option');
            option.text = item.name;
            option.value = item.value;

            if (select.dataset.selected === item.value) {
              option.selected = true;
            }

            select.append(option);
          });
        });
    });
  }

  // Boomi integration for newsletter and contact form
  function boomiIntegration() {
    const submit = document.querySelector('button.js-contact-form__submit');

    document.querySelectorAll('.contact-form__boomi').forEach(function (form) {
      const success = form.querySelector('div[data-alert="success"]');
      const fail = form.querySelector('div[data-alert="error"]');
      const inputs = form.querySelectorAll('[name]');
      const loader = form.querySelector('div.js-submit__loader');
      const newsLetterForm = document.querySelector('.js-newsletter-modal__group');
      const submitButt = form.querySelector('[type="submit"]');

      // Submit data via Fetch
      submitButt.addEventListener('click', function (e) {
        var dataToSend = formToJSON(inputs);
        dataToSend.accepts_marketing = dataToSend.accepts_marketing === "true";
        dataToSend.data_privacy = dataToSend.data_privacy === "true";
        if(form.checkValidity()){
          e.preventDefault();
          loader.classList.add('is-show');
          fetch(form.dataset.action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(dataToSend),
          })
            .then(function (response) {
              
              if (submit.classList.contains('js-newsletter-form__submit') || ($('.js-newsletter-modal').attr('style') != null && $('.js-newsletter-modal').attr('style').includes('block'))) {
                dataLayer.push({ event: 'newsletter_subscription' });
                document.cookie = "newsletter_subscribed=true; max-age=" + 365*24*60*60 + "; path=/";
                form.submit();
              } else {
                dataLayer.push({ event: 'contact_form_sent' });
                submit.disabled = true;
                success.classList.add('is-showing');
                loader.classList.remove('is-show');
                newsLetterForm.classList.add('is-hidden');
                setTimeout(function (e) {
                  success.classList.remove('is-showing');
                  success.classList.add('is-show');
                  submit.disabled = true;
                }, 200);
                form.reset();
              }
            })
            .catch(function (error) {
              fail.classList.add('is-showing');
              loader.classList.remove('is-show');
              newsLetterForm.classList.add('is-hidden');
              setTimeout(function (e) {
                fail.classList.remove('is-showing');
                fail.classList.add('is-show');
              }, 200);
            });

          let country = form.querySelector('.js-country__selector');
          country.value = country.dataset.selected;
          return false;
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    viewAll();
    countrySelector();
    boomiIntegration();
    //console.log("loaded in ios 1");
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      viewAll();
      countrySelector();
      boomiIntegration();
      //console.log("loaded in ios 2");
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    html.classList.add('' + classBrowser, '' + classOS);

    //console.log("loaded in ios 3");
  });

  //CSS background images lazy loading
  let io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        // lazy load
        if (e.target.dataset.lazyload !== 'loaded') {
          if (e.target.dataset.style) {
            e.target.style = e.target.dataset.style;
          }
          e.target.dataset.lazyload = 'loaded';
        }
      }
    });
  });

  let lazyload = document.querySelectorAll('[data-lazyload]');

  Array.prototype.forEach.call(lazyload, function (el) {
    io.observe(el);
  });

  if(!OSExc.includes(getOS())){
    let collectionProductsTileElm = document.querySelectorAll(".collection-products-tile__image");
    let collectionProductsTileWrapElm = document.querySelectorAll(".collection-products-tile__image-wrap");
    if(collectionProductsTileElm && collectionProductsTileWrapElm){
      collectionProductsTileElm.forEach(function(el){
        el.classList.add("collection-product-drop-shadow");
      });
      collectionProductsTileWrapElm.forEach(function(el){
        el.classList.add("collection-product-drop-shadow");
      });
    }
  }

  
  if (window.location.hash === "#newsletter_form_id" && window.location.search.includes("customer_posted=true")) {
      document.querySelector('.js-newsletter-modal').classList.add('success');
      setTimeout(() => {
        history.replaceState(null, null, window.location.pathname);
      }, 6000);
  }
})();
